(function(){
  'use strict';

  var rules = {
    "257373": { // Urban Hawker, NYC - Lady Wong Patisserie
      "27 November": { pickup: "2:00 PM" },
      "17 December": { pickup: "4:30 PM" },
      "24 December": { pickup: "2:00 PM", deliveryHide: ["3:30 PM","4:30 PM"] },
      "31 December": { pickup: "2:00 PM" }
    },
    "257372": { // East Village, NYC - Lady Wong Patisserie
      "27 November": { pickup: "4:00 PM", deliveryHide: ["3:30 PM","4:30 PM"] },
      "17 December": { pickup: "4:30 PM" },
      "24 December": { pickup: "4:00 PM", deliveryHide: ["3:30 PM","4:30 PM"] },
      "31 December": { pickup: "4:00 PM" }
    },
    "277972": { // Greenwich, CT - Lady Wong To-Go @ La Bistro
      "24 December": { pickup: "12:00 PM" }
    }
  };

  function toM(label){
    if(!label) return null;
    var m = label.match(/(\d{1,2})(?::(\d{2}))?\s*(AM|PM)/i);
    if(!m) return null;
    var hh = parseInt(m[1],10), mm = m[2]?parseInt(m[2],10):0, ap = m[3].toUpperCase();
    if(ap==="PM"&&hh!==12) hh+=12;
    if(ap==="AM"&&hh===12) hh=0;
    return hh*60+mm;
  }

  function currentOutlet(){
    if(window.ZapietOutletId) return String(window.ZapietOutletId);
    var r = document.querySelectorAll('input.locationRadio[id^="location_"], input.locationRadio, [data-outlet-id]');
    for(var i=0;i<r.length;i++){
      try{
        if(r[i].checked) return (r[i].getAttribute('data-outlet-id')||r[i].id||r[i].value||'').toString().replace(/^location_/,'');
      }catch(e){}
    }
    var sel = document.querySelector('[data-outlet-id].selected, [data-outlet-id].is-selected, [data-outlet-id][aria-checked="true"]');
    if(sel) return sel.getAttribute('data-outlet-id')||'';
    return '';
  }

  function selDay(){
    var el = document.querySelector('.picker__day[aria-selected="true"], .date-picker .picker__day[aria-selected="true"]');
    return el ? (el.getAttribute('aria-label')||'').trim() : '';
  }

  function buildSel(arr){ return arr.map(function(h){ return '[aria-label^="'+h+'"]'; }).join(','); }

  function hideWithTag(parent, selector, tag){
    if(!parent) return;
    var n = parent.querySelectorAll(selector);
    n.forEach(function(x){ x.setAttribute('data-zapiet-hidden-by', tag); x.style.display='none'; });
  }
  function restoreTag(parent, tag){
    if(!parent) return;
    var n = parent.querySelectorAll('[data-zapiet-hidden-by="'+tag+'"]');
    n.forEach(function(x){ x.removeAttribute('data-zapiet-hidden-by'); x.style.display=''; });
  }

  function applyPickup(){
    try{
      var o = currentOutlet();
      if(!o || !rules[o]) return;
      var lbl = selDay(); if(!lbl) return;
      var dk = null;
      Object.keys(rules[o]).forEach(function(k){ if(lbl.indexOf(k)!==-1) dk=k; });
      if(!dk) return;
      var cfg = rules[o][dk]; if(!cfg || !cfg.pickup) return;
      restoreTag(document.querySelector('.picker__list'), 'delivery');
      var cutoff = toM(cfg.pickup); if(cutoff===null) return;
      var picker = document.querySelector('.picker__list'); if(!picker) return;
      var slots = Array.prototype.slice.call(picker.querySelectorAll('[aria-label]')).map(function(el){ return {el:el, mins: toM(el.getAttribute('aria-label')), visible: (el.style.display||'') }; }).filter(function(s){ return s.mins!==null; });
      if(!slots.length) return;
      var allowed = null;
      slots.forEach(function(s){ if(s.mins<=cutoff && (allowed===null||s.mins>allowed)) allowed=s.mins; });
      if(allowed===null){ slots.forEach(function(s){ s.el.setAttribute('data-zapiet-hidden-by','pickup'); s.el.style.display='none'; }); return; }
      slots.forEach(function(s){
        if(s.mins>allowed){ s.el.setAttribute('data-zapiet-hidden-by','pickup'); s.el.style.display='none'; }
        else if(s.el.getAttribute('data-zapiet-hidden-by')==='pickup'){ s.el.removeAttribute('data-zapiet-hidden-by'); s.el.style.display=''; }
      });
    }catch(e){}
  }

  function applyDelivery(){
    try{
      var lbl = selDay(); if(!lbl) return;
      var picker = document.querySelector('.picker__list'); if(!picker) return;
      var outlet = window.ZapietOutletId?String(window.ZapietOutletId):currentOutlet();
      if(!outlet || !rules[outlet]){
        restoreTag(picker,'delivery');
        return;
      }
      var dk = null; Object.keys(rules[outlet]).forEach(function(k){ if(lbl.indexOf(k)!==-1) dk=k; });
      var hours = (dk && rules[outlet][dk] && Array.isArray(rules[outlet][dk].deliveryHide))?rules[outlet][dk].deliveryHide.slice():[];
      restoreTag(picker,'pickup');
      if(!hours.length){ restoreTag(picker,'delivery'); return; }
      hideWithTag(picker, buildSel(hours), 'delivery');
    }catch(e){}
  }

  window.ZapietOutletId = window.ZapietOutletId || '';
  if(window.ZapietEvent && window.ZapietEvent.listen){
    window.ZapietEvent.listen('locationSelected', function(p){ try{ if(p && p.location && p.location.id) window.ZapietOutletId = String(p.location.id); }catch(e){} });
    window.ZapietEvent.listen('pickup.timepicker.opened', function(){ applyPickup(); });
    window.ZapietEvent.listen('delivery.timepicker.opened', function(){ applyDelivery(); });
    window.ZapietEvent.listen('widget_loaded', function(){ setTimeout(function(){ applyPickup(); applyDelivery(); },200); });
  }

  window.__zapiet_apply_rules = function(){ applyPickup(); applyDelivery(); };

})();
